// Shared with Cypress component tests so custom floating-vue themes don't crash unregistered.
export const floatingVueOptions = {
    themes: {
        tooltip: {
            distance: 10,
            delay: {
                show: 150,
                hide: 0,
            },
        },
        'default-popup': {
            $extend: 'dropdown',
            $resetCss: true,
            distance: 8,
        },
        'information-dropdown': {
            $extend: 'dropdown',
            $resetCss: true,
            distance: 8,
        },
        'resource-tooltip': {
            $extend: 'tooltip',
            $resetCss: true,
            distance: 8,
        },
        'disabled-option-tooltip': {
            $extend: 'tooltip',
        },
        'rich-tooltip': {
            $extend: 'dropdown',
            $resetCss: true,
            distance: 12,
        },
    },
};
